import { render, staticRenderFns } from "./reductView.vue?vue&type=template&id=918b3a18&"
import script from "./reductView.vue?vue&type=script&lang=js&"
export * from "./reductView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports